<div class="text-log-dialog">
  <header class="text-log-header">
    <h2 class="text-log-title" [title]="data.fileName">{{ data.fileName }}</h2>
  </header>

  <section class="text-log-search">
    <div class="search-row">
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search in log</mat-label>
        <input
          matInput
          type="text"
          autocomplete="off"
          [formControl]="searchControl"
          placeholder="Type to search..."
          (keydown)="onSearchKeydown($event)"
        />
      </mat-form-field>

      <div class="search-nav" *ngIf="matchCount > 0">
        <span class="match-counter">{{ matchPositionLabel }}</span>
        <button
          mat-icon-button
          type="button"
          aria-label="Previous match"
          (click)="findPrevious()"
        >
          <mat-icon>keyboard_arrow_up</mat-icon>
        </button>
        <button
          mat-icon-button
          type="button"
          aria-label="Next match"
          (click)="findNext()"
        >
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      </div>
    </div>

    <div class="no-matches" *ngIf="showNoMatches">No matches found</div>
  </section>

  <section class="text-log-content" #contentScroll>
    <pre class="text-log-pre" [innerHTML]="renderedHtml"></pre>
  </section>

  <footer class="text-log-footer">
    <span class="search-hint" *ngIf="matchCount > 0">
      Use ↑ ↓ or Enter / Shift+Enter to navigate matches
    </span>
    <button mat-stroked-button type="button" (click)="close()">Close</button>
  </footer>
</div>
